<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-btn
          v-if="canEditRoles()"
          size="sm"
          variant="success"
          class="ml-1"
          :disabled="isBusy"
          @click="showModal(null, false)"
        >
          <b-spinner v-if="isBusy" small/>
          <font-awesome-icon icon="plus" class="mr-1"/>
          Новая
        </b-btn>
      </b-navbar-nav>
    </b-navbar>

    <b-navbar variant="light">
      <b-navbar-nav>
        <filters-drawer
          :query.sync="filters.query"
          :is-busy="isBusy"
          @submit="onSearch"
        />
      </b-navbar-nav>
    </b-navbar>

    <b-table
      id="user-roles"
      ref="user_roles"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="fields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #cell(active)="row">
        <font-awesome-icon v-if="!row.item.active" icon="times"/>
        <font-awesome-icon v-if="row.item.active" icon="check"/>
      </template>

      <template #cell(action)="row">
        <b-dropdown size="sm" no-caret>
          <template #button-content>
            <font-awesome-icon icon="ellipsis-v"/>
          </template>
          <b-dropdown-item-button variant="success" @click.stop="showModal(row.item.id, true)">
            <font-awesome-icon class="mr-1" icon="eye"/>
            Смотреть
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditRoles()" variant="primary" @click="showModal(row.item.id, false)">
            <font-awesome-icon icon="edit"/>
            Редактировать
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditRoles()" variant="danger" @click="onRemove(row)">
            <font-awesome-icon icon="trash"/>
            Удалить
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <UserRole ref="user_role" @refresh="getItems" @modal-closed="onModalClosed"/>

  </div>
</template>

<script>
import roles from "../../network/roles";
  import helpers from "../../utilites/helpers";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import permissions, {PERM} from "../../utilites/permissions";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
    import UserRole from "./UserRole.vue";

export default {
  name: "UserRoles",
  components: { PaginationFooter, FiltersDrawer, UserRole },
  mixins: [
    roles,
    helpers, permissions, pageSearchService
  ],
  data() {
    return {
      title: "Роли",
      isBusy: false,
      items: [],
      fields: [
        {
          key: 'id',
          label: 'id',
          sortable: false,
          class: 'userRolesId',
        },
        {
          key: 'name',
          label: 'Роль',
          sortable: false,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'userRolesAction',
          sortable: false,
        }
      ],
      sortBy: 'id',
      sortDesc: true,
      filters: {
        query: '',
      },
      deleteRow: {
        id: null,
        name: '',
      },
    }
  },
  async created() {
    this.isBusy = true;
    const query = this.$route.query;

    if (query && query.query) {
      this.filters.query = query.query;
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.onSearch();
  },
  methods: {
    showModal(userRoleId, isViewonly) {
      const canEdit = this.canEditRoles();

      if (!userRoleId) {
        if (!canEdit) return;
        this.$refs.user_role.showModal(null, false);
        return;
      }

      const isView = isViewonly || !canEdit;
      const query = isView ? { mode: 'view' } : {};

      this.$router.push({
        name: 'UserRoles',
        params: { id: userRoleId },
        query: query
      });
    },
    onModalClosed() {
      if (this.$route.params.id) {
        this.$router.replace({
          name: 'UserRoles',
          params: { id: null },
          hash: this.$route.hash,
        }).catch(()=>{});
      }
    },
    onRowClicked(item) {
      this.showModal(item.id, false);
    },
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      const result = await this.getUserRoles(data);

      if (result.data == null) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
      this.isBusy = false;
    },
    onRemove(row) {
      if (!this.canEditRoles()) return;

      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление роли";
      const message = `Вы действительно хотите сделать роль "${this.deleteRow.name}" неактивной?`;
      this.showModalDelete(title, message, function () {
        this.removeItem(this.deleteRow);
      }.bind(this));
    },
    async removeItem(row) {
      const result = await this.deleteUserRole(row);
      if (result.error) {
        this.showToast('Ошибка при удалении.', 'Ошибка', 'danger');
      } else {
        this.showToast('Роль отключена.', 'Успех', 'success');
      }
      await this.getItems();
    },
    // Permissions
    canEditRoles() {
      return this.hasPermission([PERM.ROLE_EDIT]);
    }
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        this.$nextTick(() => {
          if (newId && this.$refs.user_role) {
            const isViewonly = this.$route.query.mode === 'view';
            this.$refs.user_role.showModal(newId, isViewonly);
          } else if (!newId && this.$refs.user_role) {
            this.$refs.user_role.hideModal();
          }
        });
      }, immediate: true
    },
  }
}
</script>
<style>
.userRolesId {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.userRolesAction {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}

#user-roles td {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/UserRoles.vue